// extracted by css-extract-rspack-plugin
export default {"card":"aij6V"};